export default {
  defaultSortField: 'name',
  defaultSortOrder: 'asc',
  rearrangeCols: false,
  fields: [{
    name: 'select-catalog',
    prop: 'selected',
    width: '32px',
    title: '',
    id: 'selectCatalog',
  },{
    name: 'field-generic-input',
    prop: 'items.name',
    width: '450px',
    title: 'Production Item',
    id: 'items.name',
  }, {
    name: 'field-generic-input',
    prop: 'name',
    width: '450px',
    title: 'Source Production Order',
    id: 'name',
  }, {
    name: 'field-generic-input',
    prop: 'items.quantity',
    width: '112px',
    title: 'Qty To Ship',
    id: 'items.quantity',
  }],
};
